module.exports = __webpack_public_path__ + "static/media/logo-thebs@2x.22ad78d1.png";